import { render, staticRenderFns } from "./currency-input.vue?vue&type=template&id=3be0a2d2&scoped=true"
import script from "./currency-input.vue?vue&type=script&lang=js"
export * from "./currency-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0a2d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be0a2d2')) {
      api.createRecord('3be0a2d2', component.options)
    } else {
      api.reload('3be0a2d2', component.options)
    }
    module.hot.accept("./currency-input.vue?vue&type=template&id=3be0a2d2&scoped=true", function () {
      api.rerender('3be0a2d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/number-input/currency-input.vue"
export default component.exports